<template>
  <div class="repayment-options-header-wrapper">
    <div class="repayment-options-header-sections">
      <div class="repayment-options-header-section">Repayment Type</div>
      <div class="repayment-options-header-section repayment-option-payment-amounts-wrapper">
        <div class="payment-wrapper">{{ inSchoolLabel }}</div>
        <div class="divider"></div>
        <div class="payment-wrapper">{{ postSchoolLabel }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { withDefaults, defineProps } from "vue";

const props = withDefaults(
  defineProps<{
    inSchoolLabel?: string;
    postSchoolLabel?: string;
  }>(),
  {
    inSchoolLabel: "In-School",
    postSchoolLabel: "Post-Grad",
  },
);
</script>

<style scoped>
.repayment-options-header-wrapper {
  font-size: 10px;
  font-weight: var(--font-weight-semibold);
  margin-bottom: 6px;
}

.repayment-options-header-sections {
  display: flex;
  flex-direction: row;
  padding: 0;
  align-items: flex-start;
  width: 100%;
  font-size: 10px;
  font-weight: var(--font-weight-semibold);
  margin-bottom: 6px;
}

.repayment-options-header-section {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.repayment-options-header-section.repayment-option-payment-amounts-wrapper {
  justify-content: space-around;
}

:nth-child(2 of .repayment-options-header-section.repayment-option-payment-amounts-wrapper .payment-wrapper) {
  margin-right: 12px;
}

:nth-child(1 of .repayment-options-header-section.repayment-option-payment-amounts-wrapper .payment-wrapper) {
  margin-left: 12px;
}

:nth-child(1 of .repayment-options-header-section) {
  width: 175px;
  max-width: 185px;
}
</style>
